export const makeSelectBackgroundTasks = (state: AppState) =>
  state.backgroundTasksReducer.tasks;
